import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import { Divider } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import { CssTextField } from '../../components/common/customTextFiled';
import { Button } from '@mui/material';
import { btnSx } from '../../configs/colorConfigs';
import * as Nw from "../../components/common/NetworkInterface";
import * as commonConst from '../../components/common/Common';
import { FuncProps } from '../../components/common/Common';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import { DBService } from '../../components/common/DBServices';

export const UserForm = (fnProps: FuncProps) => {


    const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
        props,
        ref,
    ) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });

    const [sites, setSites] = React.useState<any[]>([]);

    useEffect(() => {

        const db = new DBService()
        const siteArr: any[] = []
        db.getAll("sites").then(sites => {

            if (sites) {

                for (let index = 0; index < sites.length; index++) {
                    const element = sites[index];
                    if (element.isActive == true) {
                        const data = {
                            _id: element._id,
                            name: element.name
                        }
                        siteArr.push(data)
                    }
                }

                if (fnProps.openMode === commonConst.MODE_ADD)
                    setsiteId(siteArr[0]._id)

                setSites(siteArr)
            }
        })

    }, []);

    const [name, setName] = useState(fnProps.editData ? fnProps.editData.name : "");
    const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setName(event.target.value);
    };

    const [emailId, setEmailId] = useState(fnProps.editData ? fnProps.editData.email_id : "");
    const handleEmailIdChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setEmailId(event.target.value);
    };


    const [siteId, setsiteId] = useState(fnProps.editData ? fnProps.editData.site_id : "");
    const handleSiteChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setsiteId(event.target.value);
    };


    const [successOpen, setSuccess] = useState(false);
    const [errorOpen, setError] = useState(false);

    const [isActive, setActive] = useState(fnProps.editData ? fnProps.editData.isActive: true);
    const handleActiveChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setActive(event.target.value === "1");
    };

    const [admin, setAdmin] = useState(fnProps.editData ? fnProps.editData.isActive: false);
    const handleAdminChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setAdmin(event.target.value === "1");
    };

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault()

        const patientObj = {
            name: name,
            email_id: emailId,
            isAdmin: admin,
            isActive: isActive,
            site_id: siteId,
            _id: ''
        }

        if (fnProps.editData) {
            patientObj._id = fnProps.editData._id
        }

        Nw.Post(fnProps.editData ? commonConst.EDIT_USER : commonConst.ADD_USER, patientObj, commonConst.getCommonHeader()).then(response => {

           
            if (response.data.code === 200) {
                setSuccess(true)
            } else {
                setError(true)
            }

        }).catch(error => {

            console.log(error);
            setError(true)
        })
    };

    const handleClose = () => {
        fnProps.handleClose()
    }

    const handleAPISuccess = () => {
        fnProps.refreshData()
        fnProps.handleClose()
    }

    const handleCloseSnakbar = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setSuccess(false)
        setError(false)
    };

    return (
        <div>
            <form onSubmit={handleSubmit}>
                <Grid container rowSpacing={1.5} columnSpacing={0.5} style={{ padding: "24px" }}>
                    <Grid item xs={6}>
                        <CssTextField required name='name' fullWidth value={name} label="Name" onChange={handleNameChange} />
                    </Grid>
                    <Grid item xs={6}>
                        <CssTextField name='email_id' fullWidth value={emailId} label="Email Id" onChange={handleEmailIdChange} />
                    </Grid>

                    <Grid item xs={4}>
                        <CssTextField select label="Admin" name='admin' fullWidth defaultValue="0" value={admin ? "1" : "0"} onChange={handleAdminChange}>
                            <MenuItem value="1">
                                Yes
                            </MenuItem>
                            <MenuItem value="0">
                                No
                            </MenuItem>
                        </CssTextField>
                    </Grid>
                    <Grid item xs={4}>
                        <CssTextField select label="Status" name='isActive' fullWidth defaultValue="1" value={isActive ? "1" : "0"} onChange={handleActiveChange}>
                            <MenuItem value="1">
                                Active
                            </MenuItem>
                            <MenuItem value="0">
                                InActive
                            </MenuItem>
                        </CssTextField>
                    </Grid>
                    <Grid item xs={4}>
                        <CssTextField select label="Site" name='siteId' fullWidth defaultValue="male" value={siteId} onChange={handleSiteChange}>
                            {
                                sites && sites.map((value: any) => {
                                    return (
                                        <MenuItem value={value._id} key={value._id}>{value.name}</MenuItem>
                                    )
                                })
                            }
                        </CssTextField>
                    </Grid>


                </Grid>
                <Divider style={{ marginTop: '0px' }} />
                <div style={{ padding: '10px', float: 'right' }}>
                    <Button sx={btnSx} onClick={handleClose} >Cancel</Button>
                    <Button sx={btnSx} type='submit'>{fnProps.editData ? "Update" : "Save"}</Button>
                </div>

            </form>

            <Snackbar open={successOpen} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} autoHideDuration={3000} onClose={handleAPISuccess}>
                <Alert onClose={handleCloseSnakbar} severity="success" sx={{ width: '100%' }}>
                    Data saved successfully
                </Alert>
            </Snackbar>

            <Snackbar open={errorOpen} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} autoHideDuration={3000} onClose={handleCloseSnakbar}>
                <Alert onClose={handleCloseSnakbar} severity="error" sx={{ width: '100%' }}>
                    Error while saving data
                </Alert>
            </Snackbar>

        </div>
    )
};